import r from"styled-components";import{COLORS as o}from"../../../../../constants/Theme.js";const d=r.div`
	padding: 4px 8px;
	background: ${o.surface.subdued};
	border: 1px solid ${o.stroke.primary};
	border-radius: 4px;
`;export{d as FreeFormContainer};
